import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const initialState = {
    userInfo: null,
    isLogin: false,
}

export const useAuthStore = create(
    persist(
        (set, get) => ({
            ...initialState,

            isMaster: () => {
                const user = get().userInfo
                return Boolean(user && user.isMaster)
            },
            isSubMaster: () => {
                const user = get().userInfo
                return Boolean(user && user.isSubMaster)
            },
            setUser: user => {
                set({ userInfo: user, isLogin: !!user })
            },
            reset: () => {
                set(initialState)
                useAuthStore.persist.clearStorage()
            },
        }),
        {
            name: 'auth-storage',
        },
    ),
)
